import { Table as BaseTable } from './Table';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';
import { TableFooter } from './TableFooter';
import { TableRow } from './TableRow';
import { TableHeaderCell } from './TableHeaderCell';
import { TableCell } from './TableCell';
import { TableEmpty } from './TableEmpty';

// Compound Component Pattern
const Table = Object.assign(BaseTable, {
  Header: TableHeader,
  Body: TableBody,
  Footer: TableFooter,
  Row: TableRow,
  HeaderCell: TableHeaderCell,
  Cell: TableCell,
  Empty: TableEmpty,
});

// Named exports
export { 
  Table,
  TableHeader, 
  TableBody, 
  TableFooter, 
  TableRow, 
  TableHeaderCell, 
  TableCell, 
  TableEmpty 
};

// Default export
export default Table; 